import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import * as React from 'react';

export interface IBaseSpinProps {}

const BaseSpin: React.FC<IBaseSpinProps> = ({ ...props }) => {
  return <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />;
};
export default BaseSpin;
